<template>
  <div>
    <CommonHeader :page="'Liste des utilisateurs'" />

    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <UserTable title="Table des utilisateurs"></UserTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserTable from "./Tables/UserTable";
import CommonHeader from "@/components/CommonHeader";
export default {
  name: "tables",
  components: {
    UserTable,
    CommonHeader
  }
};
</script>
<style></style>
